import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Step1 } from './components/Step1';
import { Step2 } from './components/Step2';
import { Step3 } from './components/Step3';
import { Step4 } from './components/Step4';
import { Step5 } from './components/Step5';
import { Step6 } from './components/Step6';
import { Breadcrumb } from '../../components/common/Breadcrumb/Breadcrumb';
import { GlobalData } from '../../types';
import { Complete } from './components/Complete';

declare global {
  interface Window {
    globalData: GlobalData[];
    shopUrl: string;
    expireText: string;
    retoolExpireText: string;
  }
}

const App: React.FC = () => {
  const [step, setStep] = useState<number>(1);
  const [firstCollectionHandle, setFirstCollectionHandle] = useState<string | null>(null);
  const [secondCollectionHandle, setSecondCollectionHandle] = useState<string | null>(null);
  const [productHandle, setProductHandle] = useState<string | null>(null);
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [campaignTitle, setCampaignTitle] = useState<string | undefined>(undefined);
  const [campaignSubtitle, setCampaignSubtitle] = useState<string | undefined>(undefined);
  const [isCampaign, setIsCampaign] = useState<boolean>(false);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const stepParam = params.get('step');
    const firstCollectionHandleParam = params.get('firstcollectionhandle');
    const secondCollectionHandleParam = params.get('secondcollectionhandle');
    const productHandleParam = params.get('producthandle');
    const utmTermParam = params.get('utm_term');
    const utmContentParam = params.get('utm_content');
    const utmCampaignParam = params.get('utm_campaign');

    // URLパラメーターからステップ番号を取得
    if (stepParam) {
      setStep(parseInt(stepParam, 10));
    } else {
      setStep(1);
    }

    // URLパラメーターから第一階層コレクションハンドルを取得
    if (firstCollectionHandleParam) {
      setFirstCollectionHandle(firstCollectionHandleParam);
    } else {
      setFirstCollectionHandle(null);
    }

    // URLパラメーターから第二階層コレクションハンドルを取得
    if (secondCollectionHandleParam) {
      setSecondCollectionHandle(secondCollectionHandleParam);
    } else {
      setSecondCollectionHandle(null);
    }

    // URLパラメーターから商品メニューコレクションハンドルを取得
    if (productHandleParam) {
      setProductHandle(productHandleParam);
    } else {
      setProductHandle(null);
    }

    // キャンペーンのタイトル/サブタイトルを取得（存在しない場合は undefined）
    setCampaignTitle(utmTermParam || undefined);
    setCampaignSubtitle(utmContentParam || undefined);

    // utm_campaign の有無でキャンペーンフラグを設定
    setIsCampaign(!!utmCampaignParam);
  }, [location.search]);

  // コンポーネントの切り替えの際にスクロール位置をトップに戻す
  // useEffect(() => {
  //   const htmlElement = document.documentElement;
  //   htmlElement.style.scrollBehavior = 'auto';
  //   window.scrollTo(0, 0);
  // }, [step]);

  // グローバルデータとショップURLを取得
  const data: GlobalData[] = window.globalData;
  const shopUrl = window.shopUrl;
  const expireText = window.expireText;
  const retoolExpireText = window.retoolExpireText;
  console.log(data);

  if (!data) {
    return null;
  }

  return (
    <div>
      {!(isComplete || firstCollectionHandle === 'suits_campaign') && (
        <Breadcrumb step={step} firstCollectionHandle={firstCollectionHandle} secondCollectionHandle={secondCollectionHandle} />
      )}
      {step === 1 && (
        <Step1
          data={data}
          campaignTitle={campaignTitle}
          campaignSubtitle={campaignSubtitle}
        />
      )}
      {step === 2 && <Step2 data={data} firstCollectionHandle={firstCollectionHandle} campaignTitle={campaignTitle} campaignSubtitle={campaignSubtitle} />}
      {step === 3 && (
        <Step3
          data={data}
          firstCollectionHandle={firstCollectionHandle}
          secondCollectionHandle={secondCollectionHandle}
          shopUrl={shopUrl}
          campaignTitle={campaignTitle}
          campaignSubtitle={campaignSubtitle}
          isCampaign={isCampaign}
        />
      )}
      {step === 4 && <Step4 data={data} firstCollectionHandle={firstCollectionHandle} secondCollectionHandle={secondCollectionHandle} productHandle={productHandle} expireText={expireText} />}
      {step === 5 && <Step5 data={data} firstCollectionHandle={firstCollectionHandle} secondCollectionHandle={secondCollectionHandle} productHandle={productHandle} />}
      {step === 6 && <Step6 data={data} firstCollectionHandle={firstCollectionHandle} secondCollectionHandle={secondCollectionHandle} productHandle={productHandle} setIsComplete={setIsComplete} expireText={expireText} retoolExpireText={retoolExpireText} />}
      {step === 7 &&  <Complete/>}
    </div>
  );
};

// スクロール位置をトップに戻す
const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const htmlElement = document.documentElement;
    htmlElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

export const AppWithRouter: React.FC = () => (
  <Router>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/complete" element={<Complete />} />
    </Routes>
  </Router>
);